import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import { getModule} from 'vuex-module-decorators';
import moment from 'moment';
import {CONFIG_ENV} from '@/config';
import { FileUploadService } from 'v-file-upload';
import {humanReadableBytes} from '@/modules/utils';
import nomenclatoare from '@/store/nomenclatoare';
import DialogOpenScan from '@/components/DialogOpenScan/DialogOpenScan.vue';
import iDocumentIntrare from '@/types/iDocumentIntrare';
import iNomCateg from '@/types/iNomCateg';
import iNomTipDoc from '@/types/iNomTipDoc';
import iNomRegistru from '@/types/iNomCateg';
import iScan from '@/types/iScan';
import {dateToStringDDMonYYYY} from '@/modules/utils';
import {ServicesDocument} from '@/modules/ServicesDocument';
import {ServicesScans} from '@/modules/ServicesScans';
type OrNull<T> = { [K in keyof T]: T[K] | null }
type IDocumentIntrare = OrNull<iDocumentIntrare>;

@Component({components: {DialogOpenScan}})
export default // @ts-ignore
// @ts-ignore
class WorkOnDocument extends Vue {
  @Prop({ default: '0' }) readonly appid!: string;
  @Prop({ default: 'no' }) readonly withFinalizeButton!: string
  public docApp: IDocumentIntrare;
  public loadingDocumentData:boolean = false;
  public loadingPdfForDownload:boolean = false;
  public dialogUploadFile:boolean = false;
  public myLocale:any;
  public $refs: any;
  public uploadingFileToServer:boolean=false;
  public uploadScanTitle: string  = '';
  public urlForUpload:string = '';
  public headers:any= { 'access-token': '<your-token>' };
  private storeNomenclatoare = getModule(nomenclatoare);
  public filesSelectedForUpload:any= [];
  public scans: iScan[] = [];
  // private userStore=getModule(User);

  constructor() {
    super();
    this.myLocale=CONFIG_ENV.myLocale;
    this.urlForUpload=CONFIG_ENV.URL_SCAN.uploadScan;
    this.docApp = {
      id_registru: null,
      id_categ: null,
      id_tip_doc: null,
      id_doc: null,
      data_doc: null,
      categorie_solicitant: null,
      nume_denumire: null,
      cui: null,
      titlu:null,
      descriere:null,
      nr_inreg: null,
      data_inreg: null,
      nr_file: 0,
      este_confidential: false,
      ref_nr_doc: null,
      ref_data_doc: null,
      ref_id_registru: null,
      track_creation_date: null
    }
  }


  public getDocument() {
    const vueInst=this;
    ServicesDocument.getDocumentIntrare(Number(vueInst.appid)).then((presponse)=>{
      vueInst.loadingDocumentData=false;
      if(presponse.status==='success'){
        vueInst.docApp=JSON.parse(JSON.stringify(presponse.document));
      }
    });
  }

  public getScans(){
    const vueInst=this;
    vueInst.uploadingFileToServer=true;
    ServicesScans.getScans(Number(vueInst.appid)).then((presponse)=>{
      vueInst.loadingDocumentData=false;
      if(presponse.status==='success'){
        vueInst.scans=JSON.parse(JSON.stringify(presponse.rows));
        vueInst.uploadingFileToServer=false;
      }
    });
  }

  public openFormUploadFile(){
    this.filesSelectedForUpload=[];
    this.uploadScanTitle='';
    this.dialogUploadFile=true;
  }

  public get optionsRegistre(): iNomRegistru[] {
    return JSON.parse(JSON.stringify(this.storeNomenclatoare.NomRegistre));
  }

  public get optionsCategorii(): iNomCateg[] {
    return JSON.parse(JSON.stringify(this.storeNomenclatoare.NomCategorii));
  }

  public get optionsTipDoc(): iNomTipDoc[] {
    return JSON.parse(JSON.stringify(this.storeNomenclatoare.NomTipDoc));
  }

  public displayDataDoc() :string{
    const vueInst=this;
    if(vueInst.docApp.track_creation_date){
      const day =moment(vueInst.docApp.track_creation_date.substr(0,10), "YYYY-MM-DD");
      return dateToStringDDMonYYYY(day);
    }else { return '';}


  }

  public preparePdfForDownload(){
    const vueInst = this;
    vueInst.loadingPdfForDownload=true;
    ServicesDocument.getPdfCoverDocument(Number(vueInst.appid)).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'file.pdf'); //or any other extension
      document.body.appendChild(link);
      vueInst.loadingPdfForDownload=false;
      link.click();
      link.remove();
    });
  }

  public get getLinkToQrCode():string{
    return CONFIG_ENV.URL_DOCUMENT.qr_code+'/'+this.appid;
  }

  public finalizeDocument(){
    this.$router.push({name: 'Dashboard'});
  }

  public getDenTipDocument(pIdTipDoc: number): string{
    const vueInst=this;
    let result='';
    const TipDoc = vueInst.storeNomenclatoare.NomTipDoc.find( tipdoc =>{
      return tipdoc.id_tip_doc == pIdTipDoc;
    });
    if(TipDoc){
      result=TipDoc.den_lang_1;
    }
    return result;
  }

  public humanReadableBytes(nrPfBytes:number): string{
    return humanReadableBytes(nrPfBytes);
  }

  public myUploadFile() {
    const vueInst=this;
    vueInst.uploadingFileToServer=true;
    setTimeout(function(){ vueInst.uploadingFileToServer=false;vueInst.dialogUploadFile=false;  vueInst.getScans(); }, 1000);
    let fileUpload = new FileUploadService(
      this.urlForUpload,
      this.headers,
      this.onProgress
    )
    // @ts-ignore
    fileUpload.upload(vueInst.filesSelectedForUpload, { appidDoc:vueInst.appid, id_doc: vueInst.docApp.id_doc, description:vueInst.uploadScanTitle})
      .then((e: any) => {
        // Handle success
        console.log('e=%o',e)
      })
      .catch((e: any) => {
        // Handle error
        console.log('e=%o',e)
      })
  }

  public prepareForUpload(event:any){
    this.filesSelectedForUpload = event.target.files[0];
  }

  public get checkIfFileIsSelected():boolean{
    if(this.filesSelectedForUpload.length==0){return false;}
    else{return true;}
  }
  public onProgress(event:any) {
    // Handdle the progress
  }

  @Watch('appid', { immediate: true })
  onAppidChanged1(newVal: string, oldVal: string) {
    const vueInst = this;
    vueInst.loadingDocumentData=true;
    if(Number(newVal) !=0 && Number(vueInst.appid) != 0) {
                vueInst.getDocument();
                vueInst.getScans();
    }
  }
}
